var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { margin } from 'styled-system';
import { useAriaLive } from '@ally/use-aria-live';
import SpinnerBlack from '../svgs/SpinnerBlack';
import SpinnerWhite from '../svgs/SpinnerWhite';
var sizes = {
    large: '36px',
    small: '24px',
};
var Wrapper = styled.div(margin);
var Spinner = function (_a) {
    var _b = _a.themeColor, themeColor = _b === void 0 ? 'dark' : _b, _c = _a.size, size = _c === void 0 ? 'large' : _c, _d = _a.altText, altText = _d === void 0 ? 'Loading' : _d, className = _a.className, rest = __rest(_a, ["themeColor", "size", "altText", "className"]);
    var announceAssertive = useAriaLive().announceAssertive;
    var _e = __read(useState(false), 2), ariaBusy = _e[0], setAriaBusy = _e[1];
    useEffect(function () {
        var timer = setTimeout(function () {
            setAriaBusy(true);
            announceAssertive(altText);
        }, 500);
        return function () { return clearTimeout(timer); };
    }, [altText, announceAssertive]);
    var SpinnerSVG = themeColor === 'dark' ? SpinnerBlack : SpinnerWhite;
    return (React.createElement(Wrapper, __assign({ className: className, "aria-busy": ariaBusy, "data-testid": "loading-spinner" }, rest),
        React.createElement(SpinnerSVG, { width: sizes[size], height: sizes[size] })));
};
export { Spinner, Spinner as SpinnerForProps };
//# sourceMappingURL=Spinner.js.map